export const currentReleaseType = 3
export const releaseBaseUrl = location.origin
// export const releaseBaseUrl = 'http://192.168.0.225:7000'
// export const releaseBaseUrl = 'http://qinfang.szzcloud.club'
